import { initWalletManager } from './events/initWalletManager.js';
import { activateEventBus } from './events/activateEventBus.js';
import { activateWalletEventListeners } from './listeners/index.js';
import { insertDealStarter } from './placements/dealStarter.js';
import { insertWalletBonnet } from './placements/walletBonnet.js';
import { insertWalletModal } from './placements/walletModal.js';
import { insertWalletGrid } from './placements/walletGrid.js'
import { insertSearchBudget } from './placements/walletSearchBudget.js'
import { insertTestDriveCTA } from './placements/vehicleCtas.js';
import { insertHeaderWallet } from './placements/walletHeader.js';
import { loadCSS } from './css/index.js';
import { loadWalletManager } from './events/loadWalletManager.js';
import { getTenant, getWalletScriptHost, isSectionsVDP } from './helpers/index.js';

(async APILoader => {
	// Create an instance of the API
	const API = await APILoader.create(document.currentScript || 'mywallet');

	const { InvData } = window.DDC;
	// This initializes the integration on page load.
	API.subscribe('page-load-v1', async (pageEvent) => {
		const { payload: pageData } = pageEvent;
		const { searchPage, detailPage, indexPage, layoutType , siteId} = pageData;
		const isMobile = layoutType === 'mobile';

		const config = await API.utils.getConfig();
		const { useStaging, enableDealStarter, showHeaderPlacement, defaultDownPaymentPercent, enableEsntialUds = false } = config;
		const formatDownPaymentPercent = defaultDownPaymentPercent ? parseInt(defaultDownPaymentPercent, 10)/100 : 0.2;
		const walletSubdomain = useStaging ? 'staging' : 'www';
		const walletScriptHost = getWalletScriptHost(walletSubdomain);
		const walletScriptAssetsHost = `${walletScriptHost}/assets`;
		const walletManagerHost = `${walletScriptHost}/wallet-manager`;

		const isSRP = !!(searchPage && InvData);
		const isInventoryPage = !!(searchPage || detailPage);

		loadCSS(API, config, pageData);

		// Initialize event bus
		activateEventBus();

		// Get inventory for modal and listeners (only inventory pages will have inventory)
		const vehicles = isInventoryPage ? await API.utils.getVehicleData() : [];

		// Activate the event listeners
		activateWalletEventListeners(API, isSRP, config, vehicles, indexPage, siteId, walletScriptAssetsHost, detailPage);

		// Insert the My Wallet Bonnet Shared Bundle
		await insertWalletBonnet(API, walletScriptAssetsHost);

		// Load wallet manager script and init event bus and wallet manager
		await loadWalletManager(API, walletManagerHost);
		// Initialize wallet manager
		initWalletManager(useStaging, formatDownPaymentPercent, getTenant(config));

		// Insert the My Wallet Modal code
		insertWalletModal(API, walletScriptAssetsHost, config, vehicles);

		// Insert header Wallet
		if(showHeaderPlacement){
			const { mywalletIcon } = config;
			insertHeaderWallet(API, isMobile, mywalletIcon);
		}

		if (!(isSRP || detailPage || indexPage)) {
			API.log('Not SRP, detail or index page. Aborting.');
			return;
		}


		// Insert the My Wallet Banner / Widget
		if (isSRP) {
			// Insert the My Wallet Banner / Widget
			insertWalletGrid(API, walletScriptAssetsHost, config);
		} else if (detailPage) {
			if (!isSectionsVDP()) {
				insertTestDriveCTA(API, config);
			}
			
			if (!enableEsntialUds && document.querySelector('#vehicle-build-offer')) {
				await import(
					/* webpackChunkName: 'uds' */
					'./integrations/uds.js'
				);
			}
			
			// Insert Deal Starter
			// TODO: This isn't fully working yet and further testing needs to be done.
			if (enableDealStarter) {
				insertDealStarter(API, walletScriptAssetsHost, config);
			}
		} else if (indexPage) {
			const { 
				searchByBudget, 
				showSiteTextSearchPlacement, 
				showFacetBrowsePlacement,
				facetBrowseLinkColor,
				siteTextSearchLinkColor
			} = config;
			if(showSiteTextSearchPlacement){
				insertSearchBudget(API, {searchByBudget, linkColorConfig: siteTextSearchLinkColor}, 'site-text-search');
			}
			if(showFacetBrowsePlacement){
				insertSearchBudget(API, {searchByBudget, linkColorConfig: facetBrowseLinkColor}, 'facet-browse');
			}
		}
	});
})(window.DDC.APILoader);
